import React from "react";
import {
  Page as ChakraPage,
  PageProps as ChakraPageProps,
} from "@saas-ui-pro/react";
import AnalyticsTagScopeProvider from "../../utils/AnalyticsTagScopeProvider";

export interface PageProps extends ChakraPageProps {
  analyticsTag?: string;
}

export function Page(props: PageProps) {
  return (
    <AnalyticsTagScopeProvider tag={props.analyticsTag ?? ""}>
      <ChakraPage {...props} />
    </AnalyticsTagScopeProvider>
  );
}
